// Slideshow

$('#slideshow > div:gt(0)').hide();

setInterval(function () {
  $('#slideshow > div:first')
    .fadeOut(1000)
    .next()
    .fadeIn(2000)
    .end()
    .appendTo('#slideshow');
}, 3000);

// Frequently Asked Questions
const expandables = $('.expand');
for (let i = 0; i < expandables.length; i++) {
  const answer = $('.answer')[i];
  let expanded = false;
  expandables[i].addEventListener('click', function () {
    if (!expanded) { // minimized to max
      const marginTop = 8;
      const paddingBottom = 20;
      const textHeight = $(answer).children('p')
        .height();

      $(answer).css('margin-top', `${marginTop  }px`);
      $(answer).css('padding-bottom', `${paddingBottom  }px`);
      $(answer).css('max-height', `${textHeight  }px`);
      expanded = true;
    } else { // max to minimized
      $(answer).css('margin-top', `${0  }px`);
      $(answer).css('padding-bottom', `${0  }px`);
      $(answer).css('max-height', `${0  }px`);
      expanded = false;
    }

    $(this).parent()
      .toggleClass('opened', 500);
    $(this).toggleClass('open-question', 500);
  });
}
